import React from 'react';
import { CompassIcon, LayersIcon, UserCheckIcon } from 'lucide-react';
import { selfKnowledge } from '../data/content';
const icons = [CompassIcon, LayersIcon, UserCheckIcon];
export function SelfKnowledge() {
  return <section className="bg-ivory-deep text-ink" data-id="element-167" data-mp="gahcfs3l2hk4">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-6 lg:py-16" data-id="element-168" data-mp="bizbh41k8gz5">
        <h2 className="text-center font-display text-[1.65rem] font-semibold uppercase leading-[1.1] tracking-tight sm:text-4xl" data-id="element-169" data-mp="bho835c11b8k">
          <span className="block" data-id="element-170" data-mp="l8sjjv2hudyn">{selfKnowledge.titleLine1}</span>
          <span className="block text-sage-deep" data-id="element-171" data-mp="l8iwogcqwmx6">{selfKnowledge.titleLine2}</span>
        </h2>

        <ul className="mx-auto mt-8 grid max-w-5xl gap-3 md:grid-cols-3 md:gap-4" data-id="element-172" data-mp="z7saj9dhb4xz">
          {selfKnowledge.cards.map((card, index) => {
          const Icon = icons[index];
          return <li key={card.title} className="flex gap-4 rounded-2xl bg-ivory-card p-5 ring-1 ring-stone md:flex-col md:gap-3" data-id="element-173" data-mp="3106oxygtdr9n" data-mpi={index}>
                <Icon className="mt-0.5 h-6 w-6 flex-none text-sage-deep" aria-hidden="true" data-id="element-174" data-mp="2kgh2dq6ty23r" />
                <div data-id="element-175" data-mp="2pfju68xsubts">
                  <h3 className="font-sans text-[0.85rem] font-bold uppercase leading-snug tracking-[0.06em] text-ink" data-id="element-176" data-mp="2pf0p3st8zhx6">
                    {card.title}
                  </h3>
                  <p className="mt-1.5 font-sans text-[0.93rem] leading-snug text-ink/75" data-id="element-177" data-mp="2z5d4z7q4amwz">{card.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-6 max-w-xl text-center font-sans text-xs leading-relaxed text-ink/60" data-id="element-178" data-mp="3391cjqer1ii8">
          {selfKnowledge.note}
        </p>
      </div>
    </section>;
}